<template>
  <div>
    <IsiTeks halaman="kata-pengantar" />
  </div>
</template>

<script>
import IsiTeks from '../components/IsiTeks'

export default {
  components: {
    IsiTeks
  }  
}
</script>